import { useEffect, useState } from "react";

//react pdf viewer
import { Worker } from "@react-pdf-viewer/core";
import { Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

//project import
import appLabel from "../../config/appLabel";
import { BOM } from "../../services/defined.action";
import { cnt } from "../../services/constant.action";
import history from "../../history";


const Privacy = (props) => {
  // Destructure props, including the new documentsToShow
  const { userData, isUserLogin, onSwitchModule, documentsToShow } = props;
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  // Initialize file from the documentsToShow prop, if available
  // Fallback to null or a default if documentsToShow is empty
  const [file, setFile] = useState(
    documentsToShow && documentsToShow.length > 0
      ? documentsToShow[0].link
      : null // Or a default placeholder PDF link if needed
  );
  
  // LOG: Check what documents are received by Privacy component
  useEffect(() => {
    console.log("[Privacy] Component mounted/props updated.");
    console.log("[Privacy] Received documentsToShow prop:", documentsToShow);
    console.log("[Privacy] isUserLogin prop:", isUserLogin);

    // If documentsToShow changes and a file isn't set, or if the current file isn't in the new list,
    // update the displayed file.
    if (documentsToShow && documentsToShow.length > 0) {
      if (!file || !documentsToShow.some(doc => doc.link === file)) {
        setFile(documentsToShow[0].link);
        console.log("[Privacy] Set initial/updated file to:", documentsToShow[0].link);
      }
    } else {
      setFile(null); // No documents to show, clear the viewer
      console.log("[Privacy] No documents received, clearing file.");
    }

  }, [documentsToShow, isUserLogin, file]); // Re-run when documentsToShow or isUserLogin changes

  const onViewDocument = (itemObj) => {
    // If the selected document is protected and the user isn't logged in
    if (itemObj?.isProtected && !isUserLogin) {
      BOM.AlertMsg(
        cnt.WARNING,
        "Please enter your login information to view the protected content"
      );
      // Call onSwitchModule with itemObj so ProtectedPrivacy can evaluate it
      onSwitchModule(itemObj); 
      // history.push("/protected-privacy-document"); // This push might be redundant if onSwitchModule handles navigation
    } else {
      setFile(itemObj.link); // Set the file to view
      console.log("[Privacy] Displaying document:", itemObj.name);
    }
  };

  return (
    <>
      <div className="fEx-innovative-platform">
        <div className="fEx-container-pdf">
          <div className="fEx-row">
            <>
              <div className="col-md-10">
                <div className="fEx-Innovative-img" data-aos="fade-up">
                  {/* file document here */}
                  <div
                    className="pdf-containerFAKE"
                    style={{
                      width: "100%",
                      height: "900px",
                      overflowY: "auto",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "10px",
                      boxShadow:
                        " 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    }}
                  >
                    {file ? (
                      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                        <Viewer
                          fileUrl={file}
                          plugins={[defaultLayoutPluginInstance]}
                        />
                      </Worker>
                    ) : (
                      <p>No document selected or available.</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="fEx-Innovative-info" data-aos="fade-down">
                  <span className="fEx-divider" />

                  {documentsToShow && documentsToShow.length > 0 ? (
                    <ul className="fEx-icon-list-items">
                      {documentsToShow.map((item, index) => (
                        <li key={index}>
                          <a onClick={() => onViewDocument(item)}> {/* Use onViewDocument here */}
                            <i className={item.icon} />
                            &nbsp;{item.name}
                          </a>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No privacy documents available for your role.</p>
                  )}

                  {isUserLogin ? (
                    <a
                      className="btn btn-primary btn-rounded btn-block"
                      onClick={() => history.push("/dashboard")}
                    >
                      <i className="fa fa-long-arrow-right" /> &nbsp;{" "}
                      {appLabel.goToDashboard}
                    </a>
                  ) : (
                    <a
                      className="btn btn-danger btn-rounded btn-block"
                      onClick={() => onSwitchModule({ isProtected: true })} // Pass a dummy object to ensure onSwitchModule works as expected
                    >
                      <i className="fa fa-times-circle" /> &nbsp;{" "}
                      {appLabel.closeBtn}
                    </a>
                  )}
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
